<mat-toolbar class="header" role="navigation">
  @if (backButtonVisible()) {
    <div class="icon back">
      <eop-icon [attr.aria-label]="opened ?'Close menu' : 'Navigate back'"
        class="header-arrow-left" genericButton
        identifier="header-arrow-left"
        [clickable]="true"
        (click)="opened ? closeMenuPages(sidenav) : navigateBack()"
        color="inherit"
      ></eop-icon>
    </div>
  }
  <div class="header-logo" aria-hidden="true">
    <eop-icon identifier="header" color="inherit"></eop-icon>
  </div>
  <div class="icon header-help">
    <eop-icon genericButton
      [attr.aria-label]="(sidenav.opened ? 'app.a11y.menu-close' : 'app.a11y.menu-open') | translate"
      identifier="header-help"
      [clickable]="true"
      (click)="sidenav.toggle()"
      color="inherit"
    ></eop-icon>
  </div>
</mat-toolbar>

<mat-sidenav-container class="sidenav-container">
  <mat-sidenav-content
    [ngClass]="{
      'background-map': showBackgroundMap,
      'charging-overlay-collapsed': isChargingOverlayCollapsed$ | async
    }"
    >
    <div class="main-content" role="main">
      <router-outlet (activate)="setActiveComponent($event)"></router-outlet>
    </div>
  </mat-sidenav-content>

  <mat-sidenav
    #sidenav
    mode="push"
    class="sidenav-drawer"
    [(opened)]="opened"
    (closed)="onSidenavClosed()"
    position="end">
    <div class="sidenav-content" role="navigation">
      <app-menu-pages (exit)="closeMenuPages(sidenav)" tabindex="-1"></app-menu-pages>
    </div>
  </mat-sidenav>
</mat-sidenav-container>
<!-- *ngIf="storage && storage.session" -->
<app-charging-overlay> </app-charging-overlay>

<!-- *ngIf="isLoading" -->
<app-loading-overlay> </app-loading-overlay>
